<template>
  <v-layout wrap>
    <v-flex
      xs12
    >
      <material-app-card
        class="wbs-list"
        :color="section_color"
        icon="mdi-account-plus"
        title="Additional Commercial Leader"
      >
        <div class="mb-3 px-4 pt-3 pb-5 grey lighten-2">
          <div class="font-weight-bold" style="text-align:left">Filter</div>
            <v-text-field
              outlined
              dense
              hide-details
              background-color="white"
              color="grey"
              class="mb-3"
              prepend-inner-icon="mdi-magnify"
              v-model="commercialLeader.table.filter.keyword"
            ></v-text-field>
          <div class="d-flex align-top justify-space-between">
            <div>
              <div 
                v-for="(rtfx, rtfi) in commercialLeader.table.filter.columns"
                :key="'request-table-filter-'+rtfi"
                style="width:fit-content!important"
              >
                <v-checkbox
                  dense
                  hide-details
                  :color="section_color"
                  class="mt-n1 ml-1"
                  background-color="grey lighten-2"
                  :label="rtfx.text"
                  v-model="rtfx.active"
                ></v-checkbox>
              </div>
            </div>
          </div>
        </div>
        <v-data-table
          class="extra-commercial-leader-table"
          :loading="commercialLeader.table.loading.data"
          :headers="commercialLeader.table.headers"
          :items="commercialLeaderTableItemsDisplay"
          :items-per-page="commercialLeader.table.itemsPerPage"
          :page="commercialLeader.table.page"
        >
          <template v-slot:item.approver_email="{ item }">
            <v-text-field
              v-if="item.editing || item.saving"
              :disabled="item.saving"
              outlined
              dense
              hide-details
              color="black"
              v-model="item.edit.approver_email"
            ></v-text-field>
            <v-text-field
              v-else
              disabled
              outlined
              dense
              hide-details
              color="black"
              v-model="item.approver_email"
            ></v-text-field>
          </template>
          <template v-slot:item.actions="{item}">
            <template v-if="item.saving">
              <div class="my-4" style="height:20px">Saving...</div>
            </template>
            <template v-else-if="item.deleting">
              <div class="my-4" style="height:20px">Deleting...</div>
            </template>
            <template v-else-if="item.editing">
              <v-btn
                fab
                x-small
                dark
                color="red lighten-1"
                class="ml-1"
                @click="removeEditingTableItem(item)"
              ><v-icon>mdi-trash-can</v-icon></v-btn>
              <v-btn
                fab
                x-small
                dark
                color="green lighten-1"
                class="ml-1"
                @click="saveEditingTableItem(item)"
              ><v-icon>mdi-content-save</v-icon></v-btn>
              <v-btn
                fab
                x-small
                dark
                color="blue lighten-3"
                class="ml-1"
                @click="cancelEditingTableItem(item)"
              ><v-icon>mdi-replay</v-icon></v-btn>
            </template>
            <template v-else>
              <v-btn
                fab
                x-small
                dark
                color="blue darken-1"
                class="ml-1"
                @click="editTableItem(item)"
              ><v-icon>mdi-pencil</v-icon></v-btn>
            </template>
          </template>
          <template v-slot:body.append>
            <tr 
              v-if="!commercialLeader.table.loading.data"
              class="extra-commercial-leader-table-spacer-tr-prep"
            ><td></td><td></td><td></td></tr>
            <tr
              v-for="(rtax, rtai) in commercialLeader.table.addedItems"
              :key="'request-table-added-item-'+rtai"
              class="extra-commercial-leader-table-added-item-tr"
            >
              <td>
                <v-text-field
                  class="ml-n3"
                  outlined
                  dense
                  hide-details
                  color="black"
                  backgrounr-color="white"
                  :disabled="rtax.saving"
                  v-model="rtax.requester_email"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  outlined
                  dense
                  hide-details
                  color="black"
                  backgrounr-color="white"
                  :disabled="rtax.saving"
                  v-model="rtax.approver_email"
                ></v-text-field>
              </td>
              <td>
                <div class="d-flex align-center">
                  <v-spacer></v-spacer>
                  <template v-if="rtax.saving">
                    <div class="my-4" style="height:20px">Saving...</div>
                  </template>
                  <template v-else>
                    <v-btn
                      fab
                      x-small
                      dark
                      color="green lighten-1"
                      class="ml-1"
                      @click="saveAddedTableItem(rtax)"
                    ><v-icon>mdi-content-save</v-icon></v-btn>
                    <v-btn
                      fab
                      x-small
                      dark
                      color="red lighten-2"
                      class="ml-1"
                      @click="removeAddedTableItem(rtax)"
                    ><v-icon>mdi-close</v-icon></v-btn>
                  </template>
                </div>
              </td>
            </tr>
            <tr 
              v-if="!commercialLeader.table.loading.data"
              class="extra-commercial-leader-table-add-btn-tr"
            ><td></td><td></td><td>
              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-btn
                  fab
                  x-small
                  dark
                  color="blue"
                  class="ml-1"
                  @click="addNewItem"
                ><v-icon>mdi-plus-thick</v-icon></v-btn>
              </div>
            </td></tr>
            <tr 
              v-if="!commercialLeader.table.loading.data"
              class="extra-commercial-leader-table-spacer-tr-appe"
            ><td></td><td></td><td></td></tr>
          </template>
        </v-data-table>
      </material-app-card>
    </v-flex>
  </v-layout>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import { section_color } from "@/config";
import { xPost } from '@/functions/http/axios'

export default {
  data () { return {
    me: {
      display: false,
    },
    commercialLeader: {
      table: {
        loading: {
          data: false,
        },
        filter: {
          keyword: null,
          columns: [
            {
              value: 'requester_email',
              text: 'Requestor Email',
              active: true,
            },
            {
              value: 'approver_email',
              text: 'Additional Commercial Leader Email',
              active: true,
            },
          ],
        },
        headers: [
          {
            value: 'requester_email',
            text: 'Requestor Email',
            sortable: false,
            align: 'left',
          },
          {
            value: 'approver_email',
            text: 'Additional Commercial Leader Email',
            sortable: false,
            align: 'left',
          },
          {
            value: 'actions',
            text: '',
            sortable: false,
            align: 'right',
            width: '150px',
          },
        ],
        items: [],
        addedItems: [],
        addedItemIndex: 0,
        page: 1,
        itemsPerPage: 10,
      },
    },
  }},
  computed: {
    ...mapGetters('user', [
      'loginStatus',
      // 'userEmail',actions
      // 'userInfo',
    ]),
    ...mapGetters('app', [
      'isMobile'
    ]),
    section_color() {
      return section_color['admin']
    },

    // data
    commercialLeaderTableItemsDisplay () {
      return this.commercialLeader.table.items.filter(el => 
        !(this.commercialLeader.table.filter.keyword)
        || this.commercialLeader.table.filter.columns.some(x =>
          x.active && (typeof el?.[x.value] === 'string' && el?.[x.value].toLowerCase().search(this.commercialLeader.table.filter.keyword.toLowerCase())>-1)
        )
      )
    },
  },
  methods: {
    ...mapActions('app', ['setMainTitle']),
    
    // functions
    async checkUserAccess () {
      let requestAdminAccess = await this.postRequestAdminAccess()
      if (!requestAdminAccess) {
        this.$router.push('/')
      }
    },
    async getExtraCommercialLeaders () {
      this.commercialLeader.table.loading.data = true
      let dataExtraCommercialLeaders = await this.postGetExtraCommercialLeaders()
      this.commercialLeader.table.items = dataExtraCommercialLeaders.map(x => ({
        ...x,
        edit: {
          approver_email: x?.approver_email ?? null,
        },
        editing: false,
        saving: false,
        deleting: false,
      }))
      this.commercialLeader.table.loading.data = false
    },
    editTableItem (item) {
      Object.keys(item.edit).forEach(x =>
        item.edit[x] = item[x]
      )
      item.editing = true
    },
    async saveEditingTableItem (item) {
      item.saving = true
      const { id: newID } = await this.postSaveExtraCommercialLeaders(
        item.id,
        item.requester_email,
        item.edit.approver_email
      )
      item.approver_email = item.edit.approver_email
      item.saving = false
      item.editing = false
    },
    async removeEditingTableItem (item) {
      item.deleting = true
      const { done } = await this.postRemoveExtraCommercialLeaders(
        item.id
      )
      this.commercialLeader.table.items.splice(
        this.commercialLeader.table.items.findIndex(x =>
          x.id === item.id
        ),
        1
      )
      item.deleting = false
    },
    cancelEditingTableItem (item) {
      item.editing = false
    },
    addNewItem () {
      this.commercialLeader.table.addedItemIndex +=1
      this.commercialLeader.table.addedItems.push({
        uid: this.commercialLeader.table.addedItemIndex,
        requester_email: null,
        approver_email: null,
        saving: false,
      })
    },
    async saveAddedTableItem (item) {
      const uid = item.uid
      const requester_email = item.requester_email
      const approver_email = item.approver_email
      item.saving = true
      const { id: newID } = await this.postSaveExtraCommercialLeaders(null, requester_email, approver_email)
      if (newID) {
        this.commercialLeader.table.items.splice(
          this.commercialLeader.table.items.findIndex(x =>
            x.requester_email > requester_email
          ),
          0,
          {
            id: newID,
            requester_email: item?.requester_email,
            approver_email: item?.approver_email ?? null,
            edit: {
              approver_email: item?.approver_email ?? null,
            },
            editing: false,
            saving: false,
            deleting: false,
          }
        )
        this.commercialLeader.table.addedItems.splice(
          this.commercialLeader.table.addedItems.findIndex(x =>
            x.uid === uid
          ),
          1
        )
      }
      item.saving = false
    },
    removeAddedTableItem (item) {
      this.commercialLeader.table.addedItems.splice(
        this.commercialLeader.table.addedItems.findIndex(x =>
          x.uid === item.uid
        ),
        1
      )
    },
    init () {
      this.me.display = true
      this.getExtraCommercialLeaders()
    },
    
    // post
    /**
     * request access
     */
    async postRequestAdminAccess() {
      try {
        const res = await xPost(
            'admin',
            'access',
            {
              loginStatus: this.loginStatus
            }
          )
          if (res.data.status === 200) {
            return res.data.extra_commercial_leader ?? false
          } else {
            try {
              if (res.data.message === 'Authorize Failed') {
                // this.$router.push('/login')
              }
            } catch (e) {}
            throw ''
          }
      } catch (err) {
        console.log('Error [request admin access]')
        // console.log(err)
      }
      return false
    },
    async postGetExtraCommercialLeaders() {
      try {
        const res = await xPost(
            'admin',
            'get_extra_commercial_leaders',
            {
              loginStatus: this.loginStatus
            }
          )
          if (res.data.status === 200) {
            return res.data.data ?? false
          } else {
            try {
              if (res.data.message === 'Authorize Failed') {
                // this.$router.push('/login')
              }
            } catch (e) {}
            throw ''
          }
      } catch (err) {
        console.log('Error [Get Extra Commercial Leaders]')
        // console.log(err)
      }
      return false
    },
    async postSaveExtraCommercialLeaders(id, requester_email, approver_email) {
      try {
        const res = await xPost(
            'admin',
            'save_extra_commercial_leaders',
            {
              loginStatus: this.loginStatus,
              id,
              requester_email,
              approver_email,
            }
          )
          if (res.data.status === 200) {
            return {
              id: res.data.id ?? false
            }
          } else {
            try {
              if (res.data.message === 'Authorize Failed') {
                // this.$router.push('/login')
              }
            } catch (e) {}
            throw ''
          }
      } catch (err) {
        console.log('Error [Save Extra Commercial Leaders]')
        // console.log(err)
      }
      return false
    },
    async postRemoveExtraCommercialLeaders(id) {
      try {
        const res = await xPost(
            'admin',
            'remove_extra_commercial_leaders',
            {
              loginStatus: this.loginStatus,
              id,
            }
          )
          if (res.data.status === 200) {
            return {
              done: res.data.done ?? false
            }
          } else {
            try {
              if (res.data.message === 'Authorize Failed') {
                // this.$router.push('/login')
              }
            } catch (e) {}
            throw ''
          }
      } catch (err) {
        console.log('Error [Remove Extra Commercial Leaders]')
        // console.log(err)
      }
      return false
    },
  },
  created () {
    // set title
    this.setMainTitle('Admin - Additional Commercial Leader')
    // check access
    this.checkUserAccess()
    this.init()
  },
}
</script>

<style lang="sass">
.extra-commercial-leader-table 
  .extra-commercial-leader-table-spacer-tr-prep td
    height: 2px !important
    background: #ccc
  .extra-commercial-leader-table-spacer-tr-appe td
    height: 1px !important
    background: #bbb
  .extra-commercial-leader-table-added-item-tr td
    background: #fff
  .extra-commercial-leader-table-add-btn-tr td
    background: #fff
</style>